.columns {
  @media screen and (min-width: 768px) {
    margin-bottom: 8px;
    display: flex;
    align-items: stretch;
  }
}

.columnWrapper {
  @media screen and (min-width: 768px) {
    flex: 1 0 50%;
  }
}

.column {
  padding-top: 10px;
  margin-bottom: 15px;

  @media screen and (min-width: 768px) {
    margin-bottom: 45px;
  }
}

.columnTitle {
  margin-bottom: 15px;

  @media screen and (min-width: 768px) {
    margin-bottom: 28px;
  }
}

.leftColumnWrapper {
  @media screen and (min-width: 768px) {
    padding-right: 25px;
  }
}

.rightColumnWrapper {
  @media screen and (min-width: 768px) {
    padding-left: 25px;
  }
}

.separator {
  border-radius: 1px;
  flex: 0 0 2px;
  background-color: var(--color-grey-6);
}
